import { render, staticRenderFns } from "./reservation-details.vue?vue&type=template&id=09b123d3&"
import script from "./reservation-details.vue?vue&type=script&lang=js&"
export * from "./reservation-details.vue?vue&type=script&lang=js&"
import style0 from "./reservation-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports